/* eslint-disable react/no-array-index-key */
import { useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Slider from 'react-slick';
import { Grid } from '@mui/system';
import { Paper } from '@mui/material';
import im3 from './Background.svg';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
     >
      {value === index && <Box sx={{ pt: 4 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function FarmsVet({ farmsVetSection }) {
  const [value, setValue] = useState(0);

  const settings = {
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 100,
    cssEase: 'linear',
    slidesToShow: 2.95,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '10px',
    // pauseOnHover: false,
    // pauseOnFocus: true,
    rtl: false,
    swipeToSlide: true,
    focusOnSelect: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          centerPadding: '0px',
          infinite: true,
          slidesToShow: 2.95,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerPadding: '0px',
          infinite: true,
          slidesToShow: 1.95,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          swipeToSlide: true,
        },
      },
    ],
  };

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <Grid
      className="farm-vet-section"
      style={{
        backgroundImage: `url(${im3})`,
        backgroundColor: '#D0DBD0',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}>
      <Grid container>
        <Grid size={{ xs: 12, md: 6 }}>
          <Box sx={{ borderBottom: 1, borderColor: '#999999', paddingRight: '0' }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="fullWidth tabs"
              variant="fullWidth"
              TabIndicatorProps={{
                style: {
                  backgroundColor: '#ffffff',
                },
              }}>
              {farmsVetSection?.tabs?.map((item, idx) => <Tab
                key={item?.id || idx}
                label={item?.label?.slice(0, 40)}
                {...a11yProps(idx)}
                sx={{
                  fontFamily: 'Playfair Display',
                  textTransform: 'capitalize',
                  fontSize: { sm: '14px', md: '20px' },
                  lineHeight: '30px',
                  fontWeight: 500,
                  color: '#EFEFEF',
                  padding: { xs: '4px 3px', md: '12px 16px' },
                  minWidth: '100px',
                  lineClamp: ' 1 !important',
                  display: '-webkit-box !important',
                  '-webkitLineClamp': ' 1 !important',
                  '-webkitBoxOrient': 'vertical !important',
                  overflow: ' hidden !important',
                  height: { md: '50px' },
                  '&.Mui-selected': {
                    color: '#ffffff',
                    fontWeight: 700,
                  },
                }}
            />)}

            </Tabs>
          </Box>
        </Grid>
        <Grid>
          {farmsVetSection?.tabs?.map((slides, idx) => (
            <CustomTabPanel
              key={idx}
              value={value}
              index={idx}
           >
              {/* hide this below md and shove above */}
              <Grid container columnSpacing={2} sx={{ display: { xs: 'none', md: 'flex' } }}>
                <Grid size={{ xs: 6, md: 3 }} className="web-card-wrap" sx={{ padding: '32px', borderRadius: '20px', background: '#ffffff', display: { md: 'flex', xs: 'none' }, flexDirection: 'column', justifyContent: 'center' }}>
                  { idx === 0 ? (
                    <Paper elevation={0} className="farm-vet-card-wrap">
                      <h2 className="box-title" dangerouslySetInnerHTML={{ __html: farmsVetSection?.gallaryInfo?.title }} />
                      <p className="box-subtitle">{farmsVetSection?.gallaryInfo?.description}</p>
                    </Paper>
                  ) : (
                    <Paper elevation={0} className="farm-vet-card-wrap">
                      <h2 className="box-title" dangerouslySetInnerHTML={{ __html: farmsVetSection?.vetInfoCard?.title }} />
                      <p className="box-subtitle">{farmsVetSection?.vetInfoCard?.description}</p>
                    </Paper>
                  )}
                </Grid>
                <Grid size={{ xs: 12, md: 9 }}>
                  <div className="slider-container">
                    {slides?.slides && slides.slides.length > 0 ? (
                      <Slider {...settings}>
                        {slides.slides.map((item, slideIdx) => (
                          <div style={{ margin: '0px 16px' }} key={slideIdx}>
                            <div style={{ borderRadius: '20px', overflow: 'hidden', width: 'calc(100% - 12px)' }} className="farm-vet-card-wrap">
                              <img src={`${item?.slideImage?.url}`} style={{ width: 'calc(100% - 12px)', height: '450px', objectFit: 'cover', borderRadius: '20px' }} alt="" />
                              <div className="title">{item?.title}</div>
                              <div className="description" dangerouslySetInnerHTML={{ __html: item?.description }} />
                              <div className="mask" />
                            </div>
                          </div>
                        ))}
                      </Slider>
                    ) : (
                      <div className="no-slides">No slides available</div>
                    )}
                  </div>
                </Grid>
              </Grid>
              {/* hide this above md and show below md */}
              <Grid container columnSpacing={2} sx={{ display: { md: 'none' } }}>
                <Grid size={{ xs: 12 }}>
                  <div className="slider-container">
                    {slides?.slides && slides.slides.length > 0 ? (
                      <Slider {...settings}>
                        <Grid size={{ xs: 6, md: 3 }} sx={{ padding: '32px 16px', borderRadius: '20px', background: '#ffffff', height: '100%', display: { sm: 'flex', md: 'none' }, flexDirection: 'column', justifyContent: 'center' }}>
                          {idx === 0 ? (
                            <Paper elevation={0} className="farm-vet-card-wrap">
                              <h2 className="box-title" dangerouslySetInnerHTML={{ __html: farmsVetSection?.gallaryInfo?.title }} />
                              <p className="box-subtitle">{farmsVetSection?.gallaryInfo?.description}</p>
                            </Paper>
                          ) : (
                            <Paper elevation={0} className="farm-vet-card-wrap">
                              <h2 className="box-title" dangerouslySetInnerHTML={{ __html: farmsVetSection?.vetInfoCard?.title }} />
                              <p className="box-subtitle">{farmsVetSection?.vetInfoCard?.description}</p>
                            </Paper>
                          )}
                        </Grid>
                        {slides.slides.map((item, slideIdx) => (
                          <div style={{ margin: '0px 16px' }} key={slideIdx}>
                            <div style={{ borderRight: '20px', overflow: 'hidden' }} className="farm-vet-card-wrap">
                              <img src={`${item?.slideImage?.url}`} style={{ width: 'calc(100% - 12px)', height: '450px', objectFit: 'cover', borderRadius: '20px' }} alt="" />
                              <div className="title">{item?.title}</div>
                              <div className="description" dangerouslySetInnerHTML={{ __html: item?.description }} />
                              <div className="mask" />
                            </div>
                          </div>
                        ))}
                      </Slider>
                    ) : (
                      <div className="no-slides">No slides available</div>
                    )}
                  </div>
                </Grid>
              </Grid>
            </CustomTabPanel>
          ))}
        </Grid>
      </Grid>
      <Grid />
    </Grid>

  );
}

export default FarmsVet;
